// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';
import { KLRoundIndexByRoundId } from '../constants/order';
import { KLCollectibleStatuses, type KLCollectibleId } from '../types/collectible';
import { type KLRound, KLRounds } from '../types/round';
import { KLUserStatuses } from '../types/user';

const emptyObj = {};
const emptyArray: [] = [];

export const getRoundIdFromProps = (_: StateType, { roundId }: { roundId: KLRound }) => roundId ?? null;
export const getBadgeIdFromProps = (_: StateType, { badgeId }: { badgeId: KLCollectibleId }) => badgeId ?? null;
export const getKLPoleChipIndexFromProps = (_: StateType, { index }: { index: number }) => index;
export const getStepIdFromProps = (_: StateType, { stepId }: { stepId: KLCollectibleId }) => stepId ?? null;

// #region State
export const selectKLUserState = createSelector(
  [(state: StateType) => state.kl.user ?? emptyObj],
  (userState) => userState,
);

export const selectKLUserBadges = createSelector([selectKLUserState], (userState) => userState.badges ?? emptyObj);

export const selectKLUserStatus = createSelector(
  selectKLUserState,
  (userState) => userState.status ?? KLUserStatuses.OFF,
);

export const selectHasUserNeverOptIn = createSelector(selectKLUserState, (userState) => !userState.status);

export const selectKLUserCollars = createSelector(selectKLUserState, (userState) => userState.collars ?? 0);

export const selectKLUserPendingCollars = createSelector(
  selectKLUserState,
  (userState) => userState.pendingCollars ?? 0,
);

export const selectKLUserRemainingKnifes = createSelector(
  selectKLUserState,
  (userState) => userState.remainingKnifes ?? 3,
);

export const selectKLUserLastMoveTs = createSelector(selectKLUserState, (userState) => userState.lastMoveTs);

export const selectKLUserRound = createSelector(selectKLUserState, (userState) => userState.round ?? KLRounds.T_RED);

export const selectKLUserVotes = createSelector(selectKLUserState, (userState) => userState.votes ?? 0);

export const selectKLUserNotifications = createSelector(
  selectKLUserState,
  (userState) => userState.notifications ?? null,
);

export const selectKLUserOrientation = createSelector(
  selectKLUserState,
  (userState) => userState.orientation ?? emptyArray,
);

export const selectKLUserPole = createSelector(selectKLUserState, (userState) => userState.pole ?? emptyObj);

export const selectKLUserPoleBets = createSelector(selectKLUserPole, (pole) => pole.bets ?? emptyArray);

export const selectKLUserPoleMaxAttempts = createSelector([selectKLUserPole], (pole) => pole.maxAttempts ?? 10);

export const selectKLUserPoleTotalTime = createSelector([selectKLUserPole], (pole) => pole.totalTime ?? 0);

export const selectIsKLUserEliminated = createSelector([selectKLUserStatus], (status) => status === KLUserStatuses.OUT);

export const selectKLUserRoundIndex = createSelector(
  [selectKLUserRound],
  (userRound) => KLRoundIndexByRoundId[userRound],
);

export const selectKLUserBetslips = createSelector([selectKLUserState], (userState) => userState.betslips ?? emptyObj);
// #endregion

// eslint-disable-next-line no-irregular-whitespace
// #region ({ badgeId })
export const selectKLUserBadge = createSelector(
  [getBadgeIdFromProps, selectKLUserBadges],
  (badgeId, badges) => badges[badgeId] ?? null,
);
// #endregion

// #region ({ index })
export const selectKLUserPoleBet = createSelector(
  [selectKLUserPoleBets, getKLPoleChipIndexFromProps],
  (bets, index) => bets[index] ?? emptyObj,
);

export const selectKLUserPoleBetBetslipReference = createSelector([selectKLUserPoleBet], (bet) => bet.betslipReference);

export const selectKLUserPoleBetStatus = createSelector(
  [selectKLUserPoleBet],
  (bet) => bet.status ?? KLCollectibleStatuses.OPEN,
);

export const selectKLUserPoleBetTime = createSelector([selectKLUserPoleBet], (bet) => bet.time);
// #endregion
